import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { ArticleThumbnailCard } from '@/components/modules/pages/article/Surface/ArticleThumbnailCard';
import { TopBaseSlider, TopBaseSliderItem, } from '@/components/modules/pages/top/slider/TopBaseSlider';
/**
 * TOP: コラムのスライダー
 * @param props
 * @returns
 */
export const TopColumnSlider = (props) => {
    const { className = '', items } = props;
    return (_jsx(TopBaseSlider, Object.assign({ className: className }, { children: items.map((item) => (_jsx(TopBaseSliderItem, { children: _jsx(ArticleThumbnailCard, { className: 'h-[350px]', dataType: item.dataType, displayFromAt: item.displayFromAt, fileExtension: item.fileExtension, id: item.id, isLimit: item.isLimit, themes: item.themes, thumbnailPicture: item.thumbnailPicture, title: item.title, to: item.to, weightLevel: item.weightLevel }) }, item.id))) })));
};
